module.exports = __webpack_public_path__ + "img/logo-secondary.9193eeb3.png";